import {
	createContext,
	type Dispatch,
	type FC,
	type ReactNode,
	type SetStateAction,
	useContext,
	useState,
} from "react";

type UpdatesTextContextValue = {
	updateText: string;
	setUpdateText: Dispatch<SetStateAction<string>>;
};

const UpdatesTextContext = createContext<UpdatesTextContextValue | undefined>(
	undefined,
);

const useUpdatesText = () => {
	const updatesTextContext = useContext(UpdatesTextContext);
	if (updatesTextContext === undefined) {
		throw new Error("useUpdatesText must be inside an UpdatesTextProvider");
	}
	return updatesTextContext;
};

export const UpdatesTextProvider: FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [updateText, setUpdateText] = useState("");

	return (
		<UpdatesTextContext.Provider value={{ updateText, setUpdateText }}>
			{children}
		</UpdatesTextContext.Provider>
	);
};

export default useUpdatesText;
